<h1 class="page-title">Data Exploration</h1>
<div class="main-content flex">
  <div class="col-6 border-right">
    <app-graph-form componentContext="graph-page"></app-graph-form>
  </div>
  <div class="col-8 p-5 graph-column">
    <app-graph-type componentContext="graph-page"></app-graph-type>
    <app-graph componentContext="graph-page"></app-graph>
    <app-graph-data-transformers componentContext="graph-page"></app-graph-data-transformers>
    <div class="mt-5">
      <app-graph-selected-variables-list componentContext="graph-page"></app-graph-selected-variables-list>
    </div>
  </div>
</div>
